exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".receipts-modal .sweet-modal{width:800px;max-height:90vh}.receipts-modal .sweet-modal.is-alert .sweet-content{padding:20px}", ""]);

// exports
